<template>
  <div class="layout" @click="closeMenu">
    <!-- pc的顶部菜单 -->
    <header class="header" :class="scrollPosition > 680 ? 'header-fixed' : ''">
      <div class="header-left">
        <img class="logo" src="../assets/logo.png" alt="Logo" />
      </div>
      <div class="header-center">
        <ul class="top-menu">
          <div v-for="item in topMenuData" :key="item.label">
            <div class="top-menu-item" :class="$route.name == item.path ? 'top-menu-item-active' : ''"
              v-if="item.label != '下载APP' && item.label != '联系我们'" @click="nav(item)">
              {{ item.label }}
            </div>
            <div v-if="item.label == '联系我们'" class="top-menu-item top-menu-item-contact-us" @click="contactUs">
              {{ item.label }}
              <img src="../assets/tooltip.png" alt="" class="tooltip" />
            </div>
            <div v-if="item.label == '下载APP'" class="top-menu-item top-menu-item-download-app" @click="downloadApp">{{
              item.label }}</div>
          </div>
        </ul>
      </div>
    </header>

    <!-- 移动端的顶部菜单 -->
    <header class="header-mobile">
      <!-- <div class="header-left"> -->
      <div class="header-wrap">
        <img class="logo" src="../assets/logo.png" alt="Logo" />
        <img src="../assets/menu.png" alt="" class="menu-icon" @click.stop="toggleMenu" />
      </div>

      <transition name="fade">
        <div class="menu-detail" v-if="showMenuDetail">
          <div v-for="item in topMenuData" :key="item.label">
            <div class="top-menu-item" v-if="item.label != '下载APP' && item.label != '联系我们'" @click="nav(item)">
              {{ item.label }}
            </div>
            <div v-if="item.label == '联系我们'" class="top-menu-item top-menu-item-contact-us" @click="contactUs">
              {{ item.label }}
              <img src="../assets/tooltip.png" alt="" class="tooltip" />
            </div>

            <div v-if="item.label == '下载APP'" class="top-menu-item" @click="downloadApp">{{
              item.label }}</div>
          </div>
          <div class="top-menu-item">
            <a href="weixin://dl/business/?appid=wx7f82312f73f2efa0&path=pages/home/index">打开唯果小程序</a>
          </div>
        </div>
      </transition>
    </header>

    <div class="main-container">
      <!-- 主体内容 -->
      <main class="content">
        <slot></slot>
      </main>
    </div>

    <!-- 浮动底部，只在首页展示 -->
    <div class="download-app-footer-fixed" :class="scrollPosition > 1000 ? 'download-app-footer-fixed-hidden' : ''"
      v-if="$route.name == 'home'">
      <img src="../assets/footer.png" alt="" class="only-desktop">
      <img src="../assets/footer-mobile.png" alt="" class="only-mobile">
    </div>

    <!-- bottom占位 -->
    <div class="bottom">
      <div class="left">
        <div class="title">联系我们</div>
        <div class="desc">在微信搜索Vigolive唯果租房，通过后台可以联系我们。</div>
        <div class="desc">邮箱： <a class="mail" href="mailto:supports@vigolive.cn">supports@vigolive.  cn</a> </div>
        <div class="license">
          <div @click="nav2UserLicense" class="cursor-pointer">
            用户协议
          </div>
          <div style="margin: 0 10px;">|</div>
          <div @click="nav2Privacy" class="cursor-pointer">
            隐私政策
          </div>
        </div>
      </div>

      <div class="right">
        <div class="gongan">
          <img src="@/assets/gongan.png" class="gongan-icon" alt="">
          <span>京公网安备 11010102005940号</span>
        </div>
        <a class="beian" href="https://beian.miit.gov.cn/">京ICP备2022009389号</a>
        <span>Copyright © 2022 北京积寸科技有限公司 </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router'
const router = useRouter()
const showMenuDetail = ref(false)
const toggleMenu = () => {
  showMenuDetail.value = !showMenuDetail.value
}
const nav2Privacy = () => {
  router.push({ name: "privacy" })
}
const nav2UserLicense = () => {
  router.push({ name: "user-license" })
}
const contactUs = () => {
  window.open('https://work.weixin.qq.com/kfid/kfc1ccd406a8131b623')
}
const downloadApp = () => {
  // nav
  var url = "https://static.vigolive.cn/app/"
  window.open(url)
}

// 当前滚动条位置
const scrollPosition = ref(0)
const handleScroll = () => {
  scrollPosition.value = window.scrollY
}

// 监听滚动事件
window.addEventListener('scroll', handleScroll)
const closeMenu = () => {
  console.log("close menu")
  showMenuDetail.value = false;
}
const nav = (item) => {
  console.log(item);
  router.push({ name: item.path })
  showMenuDetail.value = false;
}


// 顶部菜单数据
const topMenuData = ref([
  { label: '首页', path: "home" },
  { label: '关于我们', path: "aboutus" },
  { label: '联系我们', path: "contact-us" },
  { label: 'Q&A', path: "qa" },
  { label: '下载APP', path: "download" },

]);


</script>

<style scoped lang="less">
.cursor-pointer{
  cursor: pointer;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s;
}


.fade-enter,
.fade-leave-to,
.fade-leave-active {
  opacity: 0;
}



.only-desktop {
  display: block;
}

.only-mobile {
  display: none;
}

@media screen and (max-width: 780px) {
  .only-desktop {
    display: none;
  }

  .only-mobile {
    display: block;
  }
}


.display-none {
  display: none;
}

.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
}

.bottom {
  background-color: #171a1d;
  width: 100vw;
  /* height: 200px; */
  z-index: 999;
  display: flex;
  color: #95A0AB;
  padding: 28px 200px;
  justify-content: space-evenly;
  align-items: center;

  .left {
    flex: 1;

    .license {
      display: flex;
      margin-top: 10px;
      font-size: 13px;
      color: #6C7783;
    }

    .title {
      color: #BCC6D0;
      font-size: 16px;
      margin-bottom: 8px;
    }

    .desc {
      line-height: 24px;
      font-size: 14px;
    }

    .mail {
      text-decoration: underline;
      color: #95A0AB;
    }
  }

  .right {
    flex: 2;
    display: flex;
    align-items: center;
    font-size: 12px;


    .gongan {
      margin-right: 10px;
      align-items: center;
      display: flex;

      .gongan-icon {
        height: 14px;
        width: 14px;
        margin-right: 4px;
      }

    }

    .beian {
      margin-right: 10px;
      cursor: pointer;
      color: #95A0AB;
      text-decoration: none;

    }

    .beian:hover {
      color: white;
      transition: .3s;
    }
  }
}

@media screen and (max-width: 780px) {

  .bottom {
    background-color: #171a1d;
    width: 100vw;
    /* height: 200px; */
    z-index: 999;
    display: flex;
    color: #95A0AB;
    padding: 20px 20px;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
    text-align: center;
    box-sizing: border-box;

    .license {
      justify-content: center;

    }

    .left {
      flex: 1;

      .title {
        color: #BCC6D0;
        font-size: 16px;
        margin-bottom: 8px;
      }

      .desc {
        line-height: 24px;
        font-size: 14px;
      }

      .mail {
        text-decoration: underline;
        color: #95A0AB;
      }
    }

    .right {
      flex: 2;
      display: flex;
      align-items: center;
      font-size: 12px;
      flex-direction: column;

      margin-top: 20px;

      .gongan {
        margin-right: 10px;
        align-items: center;
        display: flex;


        .gongan-icon {
          height: 14px;
          width: 14px;
          margin-right: 4px;
        }

      }

      .beian {
        margin-top: 4px;
        margin-bottom: 4px;

        margin-right: 10px;
        cursor: pointer;
        color: #95A0AB;
        text-decoration: none;

      }

      .beian:hover {
        color: white;
        transition: .3s;
      }
    }
  }
}

.download-app-footer-fixed:hover {
  bottom: -4px;

}

.download-app-footer-fixed {
  transition: .3s;
  position: fixed;
  bottom: -4px;
  left: 0;
  right: 0;
  align-items: flex-start;
  box-sizing: border-box;
  z-index: 999;
  width: 100vw;

  img {
    width: 100%;

  }
}

.download-app-footer-fixed-hidden {
  // opacity: 0;
  bottom: -130px;
}


.header-fixed {
  background-color: black !important;
  padding: 15px 80px !important;

}

.header-mobile {
  display: none;
}

.header {
  transition: .3s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 80px;
  background: linear-gradient(#000000, 50%, #66666601);
  color: white;
  // height: 105px;
  top: 0;
  left: 0;
  right: 0;
  align-items: center;
  box-sizing: border-box;
  z-index: 999;
  position: fixed;
}

.header-left .logo {
  font-size: 20px;
  font-weight: bold;
  width: 126px;
  height: 28px;
}

.top-menu-item-active {
  position: relative;
}

.top-menu-item-active::after {
  content: "";
  background-color: rgba(13, 132, 118, 1);
  width: 100%;
  height: 3px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 3px;
}

@media screen and (max-width: 780px) {
  .header {
    display: none;
  }

  .header-mobile {
    display: block;
    color: white;
    top: 0;
    left: 0;
    right: 0;
    align-items: center;
    box-sizing: border-box;
    z-index: 999;
    position: fixed;

    .header-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: black !important;
      padding: 20px 20px;


      .logo {
        width: 102px;
        height: 20px;
      }

      .menu-icon {
        width: 22px;
        height: 22px;
      }
    }

    .menu-detail {
      background-color: #000000aa;
      transition: .3s;

      .top-menu-item-contact-us:hover .tooltip {
        display: none;
      }

      .top-menu-item {
        line-height: 48px;
        height: 48px;
        text-align: center;
        padding: 0;
        margin: 0;
        text-decoration: none;
        color: white;

        a {
          color: white;
          text-decoration: none;

        }
      }

      .top-menu-item:hover {
        background-color: transparent;
      }
    }

  }
}



.header-center .top-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  user-select: none;

}



.top-menu-item-contact-us {
  position: relative;
}

.top-menu-item-contact-us:hover .tooltip {
  display: block;
}

.tooltip {
  transition: .3s;
  width: 386px;
  height: 196px;
  position: absolute;
  top: 32px;
  right: -45px;
  display: none;
  /* opacity: 0; */
}

.top-menu-item {
  margin: 0 15px;
  cursor: pointer;
  padding: 0px 10px;
  border-radius: 5px;
  font-size: 14px;
  height: 40px;
  line-height: 43px;
  box-sizing: border-box;
  transition: .3s;
}

.top-menu-item:hover {
  background-color: var(--brand-color);

}

.top-menu-item-download-app {
  background-color: var(--brand-color);
  color: #fff;
}

.main-container {
  display: flex;
  flex: 1;
  background-color: #fff;
}

.content {
  flex: 1;
}
</style>